<div class="dropdown-div border p-0 ml-3">
    <button  #btnDropdown class="btn select ts-dropdown-fluent-toggle" type="button" data-toggle="dropdown" data-hover="dropdown" aria-haspopup="true" aria-expanded="false">
      
    </button>
    <ul class="dropdown-menu mt-1">
        <li (click)="dropdownSelection(option)" *ngFor="let option of optionArray">
            {{option.versionDisplayText}}
        </li>
    </ul>
</div>